/**
 * Prefix for local storage keys from environment variables
 * Used to prevent key collisions between different environments
 */
const keyName = process.env.REACT_APP_KEY_NAME;

/**
 * Collection of local storage keys used throughout the application
 * Each key is prefixed with the environment-specific key name
 */
export const keys = {
  /** Current logged in user data */
  CURRENT_USER: `${keyName}_CURRENT_USER`,
  /** User favorite items */
  FAVORITE: `${keyName}_FAVORITE`,
  /** User notes */
  NOTES: `${keyName}_NOTES`,
  /** User preferred language */
  LANG: `${keyName}_LANGUAGE`,
  /** User theme preference (dark/light mode) */
  DARK_MODE: `${keyName}_DARK_MODE`,
  /** User font preference */
  FONT: `${keyName}_FONT`,
  /** User defined instructions */
  INSTRUCTIONS: `${keyName}_INSTRUCTIONS`,
  /** Timestamp of last user login */
  LAST_LOGIN: `${keyName}_LAST_LOGIN`,
  /** Chat categories cache */
  CHAT_CATEGORIES: `${keyName}CHAT_CATEGORIES`,
};
